import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

export const trackBannerClick = (sc: TJsonQuery) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'BrokerDealBanner',
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
    },
  });
};
